import styled from "styled-components";

const H1 = styled.h1`
  position: relative;
  z-index: 2;
  font-weight: 700;
  font-size: 48px;
  line-height: 1.2;
  color: #2D3643;
  margin: 0;
  @media (max-width: 768px) {
    font-size: 36px;
  }
`;

export default function PageHeader({ className, children }) {
  return (
    <H1 className={className}>{children}</H1>
  )
}
